<template>
  <div>
      <h5 class="m-4 font-weight-normal">{{eticketType}}</h5>
      <!-- 兌禮記錄-介紹 begin-->
      <div class="d-flex m-4">
        <figure class="pr-2">
          <router-link to="/McfGiftDetialMobile" class="image-panel image-panel-4">
            <img
              :src="eticketImg"
              alt
              class="mw-100"
            />
          </router-link>
        </figure>
        <div class="flex-grow-1">
          <h6>{{eticketNameForWriteOff}}</h6>
          <p class="font-size-sm text-gray600">
            {{eticketDesc}}
          </p>
        </div>
      </div>
      <!-- 兌禮記錄-介紹 end-->

      <div class="bg-gray100 p-4 d-flex flex-column align-items-center" v-if="isTransfer">
        <h6 class="font-size-md">{{$t('donate.description')}}</h6>
        <div class="my-3 w-100">
          <h6 class="font-size-md"><span class="text-danger ml-n1">*</span>{{$t('donate.verification.title')}}</h6>
          <!-- 左國碼右手機號碼 begin -->
          <b-form-group>
            <Mobile
              :required="true"
              :editable="true"
              :disabled="!mobileEditable"
              :answer="mobileData"
              @updateData="updateData"
              @validateDone="validateAgain"
              ref="mobile"
            />
          </b-form-group>
          <h6 class="font-size-md"><span class="text-danger ml-n1">*</span>{{$t('donate.verification-code-validate.title')}}</h6>
          <VerificationCodeBlock ref="verificationCode"/>

          <b-button
            block
            :variant="isDisabledSend ? 'light' : '' "
            :class="{'bg-customize border-customize': !isDisabledSend}"
            v-if="!isHiddenFirstSend"
            :disabled="isDisabledSend"
            @click="validateVerificationCode();checkMember();"
            :style="`background: rgba(${rGBaCode}); border-color: rgba(${rGBaCode}); color: white`"
            >{{ $t("point-history.confirm-transfer") }}</b-button
          >
          <!-- 左國碼右手機號碼 end -->
        </div>
          <article class="my-2 font-size-md text-gray600" v-html="textRex($t('donate.precautions'))"></article>
          <Popup
            :isOpen.sync="popup.isOpen"
            :title="popup.title"
            :content="popup.content"
            :mode="popup.mode"
            @confirm="popup.confirmPopup"
          />
      </div>
      <!-- 核銷介面 -->
          <div class="bg-gray100 p-4 d-flex flex-column align-items-center" v-if="isWriteOffClick">
            <h6 class="font-size-md">{{$t('writeoff.description')}}</h6>
            <div class="my-3 w-100">
              <div v-if="eticketIsNeedWriteoffCode === false">
                <button
                  type="button"
                  class="btn px-3 py-2 w-100 border-0 bg-customize btn-primary"
                  @click="callCouponUsage()"
                >{{$t('writeoff.button')}}</button>
                <article class="my-2 font-size-md text-gray600" v-html="textRex($t('writeoff.precautions'))"></article>
              </div>
              <div v-if="eticketIsNeedWriteoffCode === true">
              <b-form-group>
                <h6 class="font-size-md"><span class="text-danger ml-n1">*</span>{{$t('writeoff.code')}}</h6>
                <b-form-input v-model="writeoffCode" type="text" class="bg-white" :placeholder="$t('writeoff.placeholder')" :state="validateState" maxlength="8"></b-form-input>
                <div class="w-100 invalid-feedback d-block" v-if="!validateState" :state="validateState">{{errorMessage}}</div><!-- 顯示錯誤訊息加d-block -->
              </b-form-group>
              <button
                type="button"
                class="btn px-3 py-2 w-100 border-0 bg-customize btn-primary"
                :disabled="isDisabledWriteOff"
                @click="callCouponUsage()"
              >{{$t('writeoff.button')}}</button>
              <article class="my-2 font-size-md text-gray600" v-html="textRex($t('writeoff.precautions'))"></article>
              </div>
            <Popup
            :isOpen.sync="popup.isOpen"
            :title="popup.title"
            :content="popup.content"
            :mode="popup.mode"
            @confirm="popup.confirmPopup"
            />
            </div>
          </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import Mobile from '@/views/mcfwallet/Mobile.vue';
import VerificationCodeBlock from '@/views/mcfwallet/VerificationCodeBlock.vue';
import Popup from '@/components/Popup.vue';

export default {
  data() {
    return {
      isAlertOpen: false,
      mobileData: {
        callingCode: '',
        mobile: '',
        mobileCountry: '',
      },
      isHiddenFirstSend: false,
      isDisabledSend: true,
      limitedAgainSendTime: '',
      validateState: undefined,
      errorMessage: '',
      stillHaveTotalSec: 0,
      timer: null,
      EndTime: '',
      isOutTime: false,
      mobileEditable: true,
      no: 0,
      activityNo: 0,
      universalCompanyTagNo: [],
      detailCompanyTagNo: [],
      isShowWriteOffPopup: false,
      writeoffCode: '',
      verificationCode: '',
      identifyCode: '',
      verificationCodeValidateWording: '',
      verificationCodeValidate: undefined,
      valid: false,
      popup: {
        // 是否開啟
        isOpen: false,
        // 標題
        title: '',
        // 內容
        content: '',
        // 顯示模式
        mode: 'hint',
        // 按確定後執行動作
        confirmPopup: () => {},
      },
      eticketType: '',
      notificationURL: '',
      isDisabledWriteOff: true,
    };
  },
  inject: ['openAlert'],
  components: {
    Mobile,
    VerificationCodeBlock,
    Popup,
  },
  created() {
    if (this.eticketTypeForWriteOff === 1) {
      this.eticketType = this.$t('mcfwallet.redeemorder');
    } else if (this.eticketTypeForWriteOff === 2) {
      this.eticketType = 'Coupon';
    }
  },
  computed: {
    ...mapState([
      'companyId',
      'memberSourceId',
      'couponName',
      'couponImage',
      'couponDesc',
      'couponLimitCnt',
      'limitDesc',
      'showTerms',
      'memberId',
      'memberAcntNo',
      'isMobile',
      'rGBaCode']),
    ...mapState('memberSource', [
      'eticketTypeForWriteOff',
      'eticketNoForWriteOff',
      'eticketNameForWriteOff',
      'eticketImg',
      'eticketDesc',
      'isWriteOffClick',
      'isTransfer',
      'companyName',
      'eticketSeqNoForWriteOff',
      'eticketIsNeedWriteoffCode']),
    fullMobileNumber() {
      // 給SMS login頁的accountID
      return this.mobileData.callingCode + this.mobileData.mobile;
    },
  },
  methods: {
    ...mapActions('memberSource', [
      'getCustomerDataMobile',
      'getAccountVerifier',
      'putCustomizeCouponUsage',
      'putWriteOffRedeemItem',
      'postCustomizeCouponTransfer',
      'postMemberNotice',
    ]),
    ...mapActions([
      'getMemberData',
    ]),
    ...mapActions('redeemItem', [
      'postRedeemOrderItemTranfer',
    ]),
    ...mapMutations(['set', 'setShowTerms']),
    ...mapMutations('memberSource', ['setMemberSourceData']),
    checkMember() {
      const vm = this;
      vm.notificationURL = `${window.location.origin}/rewards/membercenter/notification?companyid=${this.companyId}&membersourceid=${this.memberSourceId}`;
      let params = {};
      // 驗證手機號碼是否為會員
      this.getAccountVerifier(this.fullMobileNumber).then((res) => {
        if (res && (res.response.status === '701')) {
          if (vm.valid) {
            // 檢查是否為生效會員
            this.getCustomerDataMobile(this.mobileData.mobile)
              .then((getCustomerDataMobileRes) => {
                if (getCustomerDataMobileRes && getCustomerDataMobileRes.response.success) {
                  const postCustomizeCouponTransferBody = {
                    memberIdFrom: vm.memberId,
                    memberIdTo: getCustomerDataMobileRes.response.data[0].memberID,
                    couponNo: vm.eticketNoForWriteOff,
                  };
                  if (postCustomizeCouponTransferBody.memberIdFrom === postCustomizeCouponTransferBody.memberIdTo) {
                    this.$refs.mobile.setErrorMessageFromOutside({
                      errorMessage: this.$t('donate.verification.error.not-own'),
                      validateState: false,
                    });
                  } else {
                    vm.popup = {
                      isOpen: true,
                      title: vm.$t('donate.popup.title'),
                      content: vm.$t('donate.popup.description'),
                      confirmPopup: () => {
                      // 判斷轉贈電子票券可否使用後轉贈
                      // 轉贈Coupon
                        if (vm.eticketTypeForWriteOff === 2) {
                          this.postCustomizeCouponTransfer(postCustomizeCouponTransferBody)
                            .then((postCustomizeCouponTransferRes) => {
                              if (postCustomizeCouponTransferRes && postCustomizeCouponTransferRes.response.success) {
                                // 發送通知
                                this.sendNotice(postCustomizeCouponTransferBody.memberIdTo);
                                // if (!this.isMobile) {
                                // 電腦版顯示
                                params = {
                                  title: `${vm.$t('point-history.transfer-complete')}`,
                                  description: `\r\n${vm.$t('point-history.transfer-to-friend', { couponName: vm.eticketNameForWriteOff })
                                  }\r\n${vm.$t('donate.result.description')
                                  }\r\n${vm.$t('donate.result.content', { companyName: vm.companyName, couponName: vm.eticketNameForWriteOff, url: vm.notificationURL })}`,
                                  iconType: 'success',
                                  primaryButton: {
                                    text: vm.$t('donate.result.copy-message.button'),
                                    action() {
                                      vm.copyPlainText(vm.$t('donate.result.content', { companyName: vm.companyName, couponName: vm.eticketNameForWriteOff, url: vm.notificationURL }));
                                      vm.showAlert();
                                    },
                                  },
                                  secondaryButton: {
                                    text: vm.$t('donate.result.back.button'),
                                    action() {
                                      vm.$router.push({
                                        name: 'mcfwallet',
                                        query: {
                                          companyid: vm.$store.state.companyId,
                                          membersourceid: vm.$store.state.memberSourceId,
                                        },
                                      });
                                    },
                                  },
                                };
                                // } else {
                                //   // 手機版顯示
                                //   params = {
                                //     title: `${vm.$t('point-history.transfer-complete')}`,
                                //     description: `\r\n${vm.$t('point-history.transfer-to-friend', { couponName: vm.eticketNameForWriteOff })}`,
                                //     iconType: 'success',
                                //     primaryButton: {
                                //       text: vm.$t('donate.result.inform.button'),
                                //       action() {
                                //         vm.navigatorShare();
                                //       },
                                //     },
                                //     secondaryButton: {
                                //       text: vm.$t('donate.result.back.button'),
                                //       action() {
                                //         vm.$router.push({
                                //           name: 'mcfwallet',
                                //           query: {
                                //             companyid: vm.$store.state.companyId,
                                //             membersourceid: vm.$store.state.memberSourceId,
                                //           },
                                //         });
                                //       },
                                //     },
                                //   };
                                // }
                              } else {
                                params = {
                                  title: vm.$t('point-history.transfer-failed'),
                                  description: vm.$t('donate.result.fail.reason'),
                                  iconType: 'failed',
                                  primaryButton: {
                                    text: vm.$t('donate.result.back.button'),
                                    action() {
                                      vm.$router.push({
                                        name: 'mcfwallet',
                                        query: {
                                          companyid: vm.$store.state.companyId,
                                          membersourceid: vm.$store.state.memberSourceId,
                                        },
                                      });
                                    },
                                  },
                                };
                              }
                              vm.goResult(params);
                            })
                            .catch((err) => {
                              switch (err.data.status) {
                              // 已被核銷過
                                case '627':
                                  params = {
                                    title: vm.$t('point-history.transfer-failed'),
                                    description: vm.$t('donate.result.fail.reason', { situation: vm.$t('donate.result.fail.situation.isUsed') }),
                                    iconType: 'failed',
                                    primaryButton: {
                                      text: vm.$t('donate.result.back.button'),
                                      action() {
                                        vm.$router.push({
                                          name: 'mcfwallet',
                                          query: {
                                            companyid: vm.$store.state.companyId,
                                            membersourceid: vm.$store.state.memberSourceId,
                                          },
                                        });
                                      },
                                    },
                                  };
                                  vm.goResult(params);
                                  break;
                                  // 已被轉贈過
                                case '626':
                                  params = {
                                    title: vm.$t('point-history.transfer-failed'),
                                    description: vm.$t('donate.result.fail.reason', { situation: vm.$t('donate.result.fail.situation.isTransfer') }),
                                    iconType: 'failed',
                                    primaryButton: {
                                      text: vm.$t('donate.result.back.button'),
                                      action() {
                                        vm.$router.push({
                                          name: 'mcfwallet',
                                          query: {
                                            companyid: vm.$store.state.companyId,
                                            membersourceid: vm.$store.state.memberSourceId,
                                          },
                                        });
                                      },
                                    },
                                  };
                                  vm.goResult(params);
                                  break;
                                  // 已過期
                                case '625':
                                  params = {
                                    title: vm.$t('point-history.transfer-failed'),
                                    description: vm.$t('donate.result.fail.reason', { situation: vm.$t('donate.result.fail.situation.maturity') }),
                                    iconType: 'failed',
                                    primaryButton: {
                                      text: vm.$t('donate.result.back.button'),
                                      action() {
                                        vm.$router.push({
                                          name: 'mcfwallet',
                                          query: {
                                            companyid: vm.$store.state.companyId,
                                            membersourceid: vm.$store.state.memberSourceId,
                                          },
                                        });
                                      },
                                    },
                                  };
                                  vm.goResult(params);
                                  break;
                                default:
                                  params = {
                                    title: vm.$t('point-history.transfer-failed'),
                                    description: vm.$t('donate.result.fail.system-error'),
                                    iconType: 'failed',
                                    primaryButton: {
                                      text: vm.$t('donate.result.back.button'),
                                      action() {
                                        vm.$router.push({
                                          name: 'mcfwallet',
                                          query: {
                                            companyid: vm.$store.state.companyId,
                                            membersourceid: vm.$store.state.memberSourceId,
                                          },
                                        });
                                      },
                                    },
                                  };
                                  vm.goResult(params);
                                  break;
                              }
                            });
                        // 轉贈兌禮訂單
                        } else if (vm.eticketTypeForWriteOff === 1) {
                          const postRedeemOrderItemTranferBody = {
                            memberIdFrom: vm.memberId,
                            memberIdTo: getCustomerDataMobileRes.response.data[0].memberID,
                            orderNo: vm.eticketNoForWriteOff,
                            seqNo: vm.eticketSeqNoForWriteOff,
                          };
                          this.postRedeemOrderItemTranfer(postRedeemOrderItemTranferBody)
                            .then((postRedeemOrderItemTranferRes) => {
                              if (postRedeemOrderItemTranferRes && postRedeemOrderItemTranferRes.response.success) {
                                // 發送通知
                                vm.sendNotice(postRedeemOrderItemTranferBody.memberIdTo);
                                // if (!this.isMobile) {
                                // 電腦版顯示
                                params = {
                                  title: `${vm.$t('point-history.transfer-complete')}`,
                                  description: `\r\n${vm.$t('point-history.transfer-to-friend', { couponName: vm.eticketNameForWriteOff })
                                  }\r\n${vm.$t('donate.result.description')
                                  }\r\n${vm.$t('donate.result.content', { companyName: vm.companyName, couponName: vm.eticketNameForWriteOff, url: vm.notificationURL })}`,
                                  iconType: 'success',
                                  primaryButton: {
                                    text: vm.$t('donate.result.copy-message.button'),
                                    action() {
                                      vm.copyPlainText(vm.$t('donate.result.content', { companyName: vm.companyName, couponName: vm.eticketNameForWriteOff, url: vm.notificationURL }));
                                      vm.showAlert();
                                    },
                                  },
                                  secondaryButton: {
                                    text: vm.$t('donate.result.back.button'),
                                    action() {
                                      vm.$router.push({
                                        name: 'mcfwallet',
                                        query: {
                                          companyid: vm.$store.state.companyId,
                                          membersourceid: vm.$store.state.memberSourceId,
                                        },
                                      });
                                    },
                                  },
                                };
                                // }
                                // 手機版顯示
                                //  else {
                                //   params = {
                                //     title: `${vm.$t('point-history.transfer-complete')}`,
                                //     description: `\r\n${vm.$t('point-history.transfer-to-friend', { couponName: vm.eticketNameForWriteOff })}`,
                                //     iconType: 'success',
                                //     primaryButton: {
                                //       text: vm.$t('donate.result.inform.button'),
                                //       action() {
                                //         vm.navigatorShare();
                                //       },
                                //     },
                                //     secondaryButton: {
                                //       text: vm.$t('donate.result.back.button'),
                                //       action() {
                                //         vm.$router.push({
                                //           name: 'mcfwallet',
                                //           query: {
                                //             companyid: vm.$store.state.companyId,
                                //             membersourceid: vm.$store.state.memberSourceId,
                                //           },
                                //         });
                                //       },
                                //     },
                                //   };
                                // }
                              } else {
                                params = {
                                  title: vm.$t('point-history.transfer-failed'),
                                  description: vm.$t('donate.result.fail.reason'),
                                  iconType: 'failed',
                                  primaryButton: {
                                    text: vm.$t('donate.result.back.button'),
                                    action() {
                                      vm.$router.push({
                                        name: 'mcfwallet',
                                        query: {
                                          companyid: vm.$store.state.companyId,
                                          membersourceid: vm.$store.state.memberSourceId,
                                        },
                                      });
                                    },
                                  },
                                };
                              }
                              vm.goResult(params);
                            })
                            .catch((err) => {
                              switch (err.data.status) {
                              // 已被核銷過
                                case '627':
                                  params = {
                                    title: vm.$t('point-history.transfer-failed'),
                                    description: vm.$t('donate.result.fail.reason', { situation: vm.$t('donate.result.fail.situation.isUsed') }),
                                    iconType: 'failed',
                                    primaryButton: {
                                      text: vm.$t('donate.result.back.button'),
                                      action() {
                                        vm.$router.push({
                                          name: 'mcfwallet',
                                          query: {
                                            companyid: vm.$store.state.companyId,
                                            membersourceid: vm.$store.state.memberSourceId,
                                          },
                                        });
                                      },
                                    },
                                  };
                                  vm.goResult(params);
                                  break;
                                  // 已被轉贈過
                                case '626':
                                  params = {
                                    title: vm.$t('point-history.transfer-failed'),
                                    description: vm.$t('donate.result.fail.reason', { situation: vm.$t('donate.result.fail.situation.isTransfer') }),
                                    iconType: 'failed',
                                    primaryButton: {
                                      text: vm.$t('donate.result.back.button'),
                                      action() {
                                        vm.$router.push({
                                          name: 'mcfwallet',
                                          query: {
                                            companyid: vm.$store.state.companyId,
                                            membersourceid: vm.$store.state.memberSourceId,
                                          },
                                        });
                                      },
                                    },
                                  };
                                  vm.goResult(params);
                                  break;
                                  // 已過期
                                case '625':
                                  params = {
                                    title: vm.$t('point-history.transfer-failed'),
                                    description: vm.$t('donate.result.fail.reason', { situation: vm.$t('donate.result.fail.situation.maturity') }),
                                    iconType: 'failed',
                                    primaryButton: {
                                      text: vm.$t('donate.result.back.button'),
                                      action() {
                                        vm.$router.push({
                                          name: 'mcfwallet',
                                          query: {
                                            companyid: vm.$store.state.companyId,
                                            membersourceid: vm.$store.state.memberSourceId,
                                          },
                                        });
                                      },
                                    },
                                  };
                                  vm.goResult(params);
                                  break;
                                default:
                                  params = {
                                    title: vm.$t('point-history.transfer-failed'),
                                    description: vm.$t('donate.result.fail.system-error'),
                                    iconType: 'failed',
                                    primaryButton: {
                                      text: vm.$t('donate.result.back.button'),
                                      action() {
                                        vm.$router.push({
                                          name: 'mcfwallet',
                                          query: {
                                            companyid: vm.$store.state.companyId,
                                            membersourceid: vm.$store.state.memberSourceId,
                                          },
                                        });
                                      },
                                    },
                                  };
                                  vm.goResult(params);
                                  break;
                              }
                            });
                        }
                      },
                    };
                  }
                }
              })
              .catch((err) => {
                if (err.data.status === '605') {
                  this.$refs.mobile.setErrorMessageFromOutside({
                    errorMessage: this.$t('donate.verification.error.invalidation'),
                    validateState: false,
                  });
                }
              });
          }
        } else {
          this.$refs.mobile.setErrorMessageFromOutside({
            errorMessage: this.$t('donate.verification.error.no-member'),
            validateState: false,
          });
        }
      });
    },
    validateAgain() {
      this.$nextTick(() => {
        if (!this.$refs.mobile.validateState) {
          this.isDisabledSend = true;
          switch (this.$refs.mobile.errorMessage) {
            case this.$t('pleaseEnterPhoneNumberInfo'):
              this.$refs.mobile.setErrorMessageFromOutside({
                errorMessage: this.$t('donate.verification.press-phone-number.require'),
                validateState: false,
              });
              break;
            default:
              break;
          }
        } else {
          this.isDisabledSend = false;
        }
      });
    },
    updateData(data) {
      this.mobileData = data.value;
    },
    textRex(text) {
      return text.replace(/\r\n/g, '<br />');
    },
    // 驗證驗證碼
    validateVerificationCode() {
      const vm = this;

      const verificationCodeValid = vm.$refs.verificationCode.verify();
      vm.valid = false;
      if (verificationCodeValid) {
        vm.valid = true;
      }
    },
    validWriteOffCode() {
      if (this.writeoffCode !== '') {
      // 如果全部都數字
        const regx = /^[A-Za-z0-9]*$/;
        if (regx.test(this.writeoffCode) && this.writeoffCode.length <= 8) {
          this.validateState = true;
          this.isDisabledWriteOff = false;
        } else {
        // 有除了英數字以外的字元 or 檢查錯誤
          this.errorMessage = this.$t('writeoff.error');
          this.validateState = false;
          this.isDisabledWriteOff = true;
        }
      } else {
        this.errorMessage = this.$t('writeoff.error');
        this.validateState = false;
        this.isDisabledWriteOff = true;
      }
    },
    writeOffPopup() {
      if (this.validateState === true) {
        this.isShowWriteOffPopup = true;
      }
    },
    callCouponUsage() {
      const vm = this;
      let params = {};
      // 兌禮
      if (this.eticketTypeForWriteOff === 1) {
        const payload = {
          orderNo: this.eticketNoForWriteOff,
          seqNo: this.eticketSeqNoForWriteOff,
          reimbursementCode: this.writeoffCode,
        };
        vm.popup = {
          isOpen: true,
          title: vm.$t('writeoff.popup.title'),
          content: vm.$t('writeoff.popup.description'),
          confirmPopup: () => {
            this.putWriteOffRedeemItem(payload)
              .then((res) => {
                if (res && res.success) {
                  // 電腦版顯示
                  if (!this.isMobile) {
                    params = {
                      title: `${vm.$t('writeoff.complete.title-success')}`,
                      description: `${vm.$t('writeoff.complete.description-success', { couponName: this.eticketNameForWriteOff })}`,
                      iconType: 'success',
                      primaryButton: {
                        text: vm.$t('writeoff.complete.button'),
                        action() {
                          vm.$router.push({
                            name: 'mcfwallet',
                            query: {
                              companyid: vm.$store.state.companyId,
                              membersourceid: vm.$store.state.memberSourceId,
                            },
                          });
                        },
                      },
                    };
                    // 手機版顯示
                  } else {
                    this.setMemberSourceData({ id: 'isWriteOffClick', value: false });
                    params = {
                      title: `${vm.$t('writeoff.complete.title-success')}`,
                      description: `${vm.$t('writeoff.complete.description-success', { couponName: this.eticketNameForWriteOff })}`,
                      iconType: 'success',
                      primaryButton: {
                        text: vm.$t('writeoff.complete.button'),
                        action() {
                          vm.$router.push({
                            name: 'mcfwallet',
                            query: {
                              companyid: vm.$store.state.companyId,
                              membersourceid: vm.$store.state.memberSourceId,
                            },
                          });
                        },
                      },
                    };
                  }
                }
                // 前往轉贈結果頁
                vm.$router.push({
                  name: 'complete',
                  query: {
                    companyid: vm.$store.state.companyId,
                    membersourceid: vm.$store.state.memberSourceId,
                  },
                  params,
                });
              })
              .catch((err) => {
                switch (err.data.status) {
                  case '627':
                    // 已核銷
                    this.setMemberSourceData({ id: 'isWriteOffClick', value: false });
                    params = {
                      title: vm.$t('writeoff.complete.title-fail'),
                      description: vm.$t('writeoff.complete.description-fail627'),
                      iconType: 'failed',
                      primaryButton: {
                        text: vm.$t('donate.result.back.button'),
                        action() {
                          vm.$router.push({
                            name: 'mcfwallet',
                            query: {
                              companyid: vm.$store.state.companyId,
                              membersourceid: vm.$store.state.memberSourceId,
                            },
                          });
                        },
                      },
                    };
                    vm.goResult(params);
                    break;
                  case '626':
                    // 已轉贈
                    this.setMemberSourceData({ id: 'isWriteOffClick', value: false });
                    params = {
                      title: vm.$t('writeoff.complete.title-fail'),
                      description: vm.$t('writeoff.complete.description-fail626'),
                      iconType: 'failed',
                      primaryButton: {
                        text: vm.$t('donate.result.back.button'),
                        action() {
                          vm.$router.push({
                            name: 'mcfwallet',
                            query: {
                              companyid: vm.$store.state.companyId,
                              membersourceid: vm.$store.state.memberSourceId,
                            },
                          });
                        },
                      },
                    };
                    vm.goResult(params);
                    break;
                  case '625':
                    // 已過期
                    this.setMemberSourceData({ id: 'isWriteOffClick', value: false });
                    params = {
                      title: vm.$t('writeoff.complete.title-fail'),
                      description: vm.$t('writeoff.complete.description-fail625'),
                      iconType: 'failed',
                      primaryButton: {
                        text: vm.$t('donate.result.back.button'),
                        action() {
                          vm.$router.push({
                            name: 'mcfwallet',
                            query: {
                              companyid: vm.$store.state.companyId,
                              membersourceid: vm.$store.state.memberSourceId,
                            },
                          });
                        },
                      },
                    };
                    vm.goResult(params);
                    break;
                  default:
                    params = {
                      title: vm.$t('writeoff.complete.title-fail'),
                      description: vm.$t('donate.result.fail.system-error'),
                      iconType: 'failed',
                      primaryButton: {
                        text: vm.$t('donate.result.back.button'),
                        action() {
                          vm.$router.push({
                            name: 'mcfwallet',
                            query: {
                              companyid: vm.$store.state.companyId,
                              membersourceid: vm.$store.state.memberSourceId,
                            },
                          });
                        },
                      },
                    };
                    vm.goResult(params);
                    break;
                }
              });
            this.setMemberSourceData({ id: 'isWriteOffClick', value: false });
          },
        };
      }
      // 核銷
      if (this.eticketTypeForWriteOff === 2) {
        const payload = {
        // couponNo: payload.couponNo,
        // orderSum: payload.orderSum,
          couponNo: this.eticketNoForWriteOff,
          reimbursementCode: this.writeoffCode,
        };
        vm.popup = {
          isOpen: true,
          title: vm.$t('writeoff.popup.title'),
          content: vm.$t('writeoff.popup.description'),
          confirmPopup: () => {
            this.putCustomizeCouponUsage(payload)
              .then((res) => {
                if (res && res.success) {
                // 電腦版顯示
                  if (!this.isMobile) {
                    this.setMemberSourceData({ id: 'isWriteOffClick', value: false });
                    params = {
                      title: `${vm.$t('writeoff.complete.title-success')}`,
                      description: `${vm.$t('writeoff.complete.description-success', { couponName: this.eticketNameForWriteOff })}`,
                      iconType: 'success',
                      primaryButton: {
                        text: vm.$t('writeoff.complete.button'),
                        action() {
                          vm.$router.push({
                            name: 'mcfwallet',
                            query: {
                              companyid: vm.$store.state.companyId,
                              membersourceid: vm.$store.state.memberSourceId,
                            },
                          });
                        },
                      },
                    };
                    // 手機版顯示
                  } else {
                    this.setMemberSourceData({ id: 'isWriteOffClick', value: false });
                    params = {
                      title: `${vm.$t('writeoff.complete.title-success')}`,
                      description: `${vm.$t('writeoff.complete.description-success', { couponName: this.eticketNameForWriteOff })}`,
                      iconType: 'success',
                      primaryButton: {
                        text: vm.$t('writeoff.complete.button'),
                        action() {
                          vm.$router.push({
                            name: 'mcfwallet',
                            query: {
                              companyid: vm.$store.state.companyId,
                              membersourceid: vm.$store.state.memberSourceId,
                            },
                          });
                        },
                      },
                    };
                  }
                }
                vm.goResult(params);
              })
              .catch((err) => {
                switch (err.data.status) {
                  case '627':
                    // 已核銷
                    this.setMemberSourceData({ id: 'isWriteOffClick', value: false });
                    params = {
                      title: vm.$t('writeoff.complete.title-fail'),
                      description: vm.$t('writeoff.complete.description-fail627'),
                      iconType: 'failed',
                      primaryButton: {
                        text: vm.$t('donate.result.back.button'),
                        action() {
                          vm.$router.push({
                            name: 'mcfwallet',
                            query: {
                              companyid: vm.$store.state.companyId,
                              membersourceid: vm.$store.state.memberSourceId,
                            },
                          });
                        },
                      },
                    };
                    vm.goResult(params);
                    break;
                  case '626':
                    // 已轉贈
                    this.setMemberSourceData({ id: 'isWriteOffClick', value: false });
                    params = {
                      title: vm.$t('writeoff.complete.title-fail'),
                      description: vm.$t('writeoff.complete.description-fail626'),
                      iconType: 'failed',
                      primaryButton: {
                        text: vm.$t('donate.result.back.button'),
                        action() {
                          vm.$router.push({
                            name: 'mcfwallet',
                            query: {
                              companyid: vm.$store.state.companyId,
                              membersourceid: vm.$store.state.memberSourceId,
                            },
                          });
                        },
                      },
                    };
                    vm.goResult(params);
                    break;
                  case '625':
                    // 已過期
                    this.setMemberSourceData({ id: 'isWriteOffClick', value: false });
                    params = {
                      title: vm.$t('writeoff.complete.title-fail'),
                      description: vm.$t('writeoff.complete.description-fail625'),
                      iconType: 'failed',
                      primaryButton: {
                        text: vm.$t('donate.result.back.button'),
                        action() {
                          vm.$router.push({
                            name: 'mcfwallet',
                            query: {
                              companyid: vm.$store.state.companyId,
                              membersourceid: vm.$store.state.memberSourceId,
                            },
                          });
                        },
                      },
                    };
                    vm.goResult(params);
                    break;
                  default:
                    params = {
                      title: vm.$t('writeoff.complete.title-fail'),
                      description: vm.$t('donate.result.fail.system-error'),
                      iconType: 'failed',
                      primaryButton: {
                        text: vm.$t('donate.result.back.button'),
                        action() {
                          vm.$router.push({
                            name: 'mcfwallet',
                            query: {
                              companyid: vm.$store.state.companyId,
                              membersourceid: vm.$store.state.memberSourceId,
                            },
                          });
                        },
                      },
                    };
                    vm.goResult(params);
                    break;
                }
              });
          },
        };
      }
    },
    goResult(params) {
      params.pageTitle = this.$t('mcfwallet.title');
      // 前往轉贈結果頁
      this.$router.push({
        name: 'complete',
        query: {
          companyid: this.$store.state.companyId,
          membersourceid: this.$store.state.memberSourceId,
        },
        params,
      });
    },
    showAlert() {
      if (!this.isAlertOpen) {
        this.openAlert({
          title: this.$t('donate.result.copy-message.copy-already'), // 標題
          variant: 'light',
          dismissSec: 5, // 顯示多久後隱藏 (sec)
        });
        this.isAlertOpen = true;
        setTimeout(() => {
          this.isAlertOpen = false;
        }, 5000);
      }
    },
    copyPlainText(plainText) {
      if (window.isSecureContext && navigator.clipboard) {
        navigator.clipboard.writeText(plainText);
      }
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

      if (document.execCommand) {
        if (isiOS) {
          const oInput = document.createElement('textarea'); // 建立一個隱藏input（重要！）；因 input不支援換行，改用 textarea
          oInput.disabled = true;
          oInput.value = plainText; // 賦值
          document.body.appendChild(oInput);
          oInput.select(); // 選擇物件
          document.execCommand('copy'); // 執行瀏覽器複製命令
          oInput.blur();
          oInput.className = 'oInput';
          oInput.style.display = 'none';
        } else {
          const oInput = document.createElement('textarea'); // 建立一個隱藏input（重要！）；因 input不支援換行，改用 textarea
          oInput.value = plainText; // 賦值
          document.body.appendChild(oInput);
          oInput.select(); // 選擇物件
          document.execCommand('copy'); // 執行瀏覽器複製命令
          oInput.className = 'oInput';
          oInput.style.display = 'none';
        }
      }

      return false;
    },
    navigatorShare() {
      const vm = this;
      const contentText = vm.$t('donate.result.content', { companyName: vm.companyName, couponName: vm.eticketNameForWriteOff, url: vm.notificationURL });
      // 若支援分享功能，分享邀請文字
      if (navigator.share) {
        navigator.share({
          text: contentText,
        });
      // 若支援剪貼簿功能，複製通知文字
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(contentText);
      }
    },
    sendNotice(memberIdTo) {
      const vm = this;
      vm.getMemberData().then((memberData) => {
        const title = this.$t('writeoff.notice-title', { name: vm.eticketType });
        const href = `${window.location.origin}/rewards/membercenter/mcfwallet?companyid=${this.companyId}&membersourceid=${this.memberSourceId}`;
        const content = this.$t('writeoff.notice-content', { name: memberData.name, gift: vm.eticketNameForWriteOff, href });

        const body = {
          compnayID: this.companyId,
          noticeInfo: [
            {
              memberID: [memberIdTo],
              title,
              content,
              attachmentUrl: vm.eticketImg,
              attachmentName: vm.getFileNameFromUrl(vm.eticketImg),
            },
          ],
        };
        vm.postMemberNotice(body);
      });
    },
    // 取得URL中的檔案名稱
    getFileNameFromUrl(url) {
      // eslint-disable-next-line newline-per-chained-call
      return url.split('#').shift().split('?').shift().split('/').pop();
    },
  },
  watch: {
    writeoffCode() {
      this.validWriteOffCode();
    },
  },
};
</script>

<style>
</style>
